module.exports = __webpack_public_path__ + "static/about_home-f400e719a215dde851c60c177e6f3e9a.png";